var React = require('react');

function Electric (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"a","x1":"45.322%","x2":"54.678%","y1":"0%","y2":"100%"},[React.createElement("stop",{"offset":"0%","stopColor":"#311B77","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#FF2DFF","key":1})])),React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"url(#a)","strokeLinejoin":"round","strokeWidth":"4","d":"M216.548 2064l-19.23 86.706-4.028 18.157 15.266-9.344 13.913-8.517L193 2234l45.451-94.012 6.549-13.543-14.51 6.448-12.74 5.663L240.622 2064h-24.075zM237 2075h-22.5l1-4h23l-1.5 4zm-25 11h21.5l.5-2h-21.5l-.5 2zm-3 10.5h23","transform":"translate(-191 -2062)","key":1})]);
}

Electric.defaultProps = {"viewBox":"0 0 56 174"};

module.exports = Electric;

Electric.default = Electric;
